<template>
  <div>
    <h2
      class="kbx-description"
      v-if="stepPreview.description_visibility"
      klickbox-edit-item="description"
      :klickbox-edit-label="$t('edit.canvas.question_description')"
      :style="stepStyle('description')">
      <text-editor
        v-if="!stepPreview.isGeneral"
        :content="stepPreview.description_text"
        :change="onChange"
        :toolbar="true"
        :placeholder="$t('edit.canvas.question_description_placeholder')">
      </text-editor>
      <span v-else>{{stepPreview.description_text}}</span>
    </h2>
  </div>
</template>

<script>
import TextEditor from 'src/components/general/TextEditor/Main';
import { mapGetters } from 'vuex';

export default {
  components: {
    TextEditor,
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
    stepPreview: 'stepPreview',
  }),
  methods: {
    onChange(text) {
      this.$store.dispatch('stepUpdateDescriptionText', {
        event: { target: { value: text } },
        id: this.stepPreview.id,
      });
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** Description.vue?5fb31120
 **/